import { workflowConstants } from "../_constants";
import { workflowServices } from "../_services";
import { alertActions } from ".";

export const workflowActions = {
  getAllWorkflow,
  getWorkflowById,
  getWorkflowTopCard,
  addWorkflow,
  editWorkflowById,
  addConfiguredWorkflowById,
  runWorkflowByJobId,
  getDatabricksJobStatus,
  searchWorkflow,
  getWorkflowFilters,
  applyWorkflowFilters,
  getGitRepoByConnectionId,
  activateWorkflow,
  getActiveWorkflowByConnectionId
};

function getAllWorkflow(offset, limit) {
  return (dispatch) => {
    dispatch(request());
    workflowServices.getAllWorkflow(offset, limit).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: workflowConstants.GET_ALL_WORKFLOW_REQUEST };
  }
  function success(data) {
    return { type: workflowConstants.GET_ALL_WORKFLOW_SUCCESS, data };
  }
  function failure(error) {
    return { type: workflowConstants.GET_ALL_WORKFLOW_FAILURE, error };
  }
}

function getWorkflowById(workflowId) {
  return (dispatch) => {
    dispatch(request());
    workflowServices.getWorkflowById(workflowId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: workflowConstants.GET_WORKFLOW_BY_ID_REQUEST };
  }
  function success(data) {
    return { type: workflowConstants.GET_WORKFLOW_BY_ID_SUCCESS, data };
  }
  function failure(error) {
    return { type: workflowConstants.GET_WORKFLOW_BY_ID_FAILURE, error };
  }
}

function getWorkflowTopCard() {
  return (dispatch) => {
    dispatch(request());
    workflowServices.getWorkflowTopCard().then(
      (data) => {
        dispatch(success(data));
      },
      (error) => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request() {
    return { type: workflowConstants.GET_WORKFLOW_TOP_CARD_REQUEST };
  }
  function success(data) {
    return { type: workflowConstants.GET_WORKFLOW_TOP_CARD_SUCCESS, data };
  }
  function failure(error) {
    return { type: workflowConstants.GET_WORKFLOW_TOP_CARD_FAILURE, error };
  }
}

function addWorkflow(formData) {
  return (dispatch) => {
    dispatch(request());
    workflowServices.addWorkflow(formData).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: workflowConstants.ADD_WORKFLOW_REQUEST };
  }
  function success(data) {
    return {
      type: workflowConstants.ADD_WORKFLOW_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: workflowConstants.ADD_WORKFLOW_FAILURE, error };
  }
}

function editWorkflowById(workflowId, formData) {
  return (dispatch) => {
    dispatch(request());
    workflowServices.editWorkflowById(workflowId, formData).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: workflowConstants.EDIT_WORKFLOW_BY_ID_REQUEST };
  }
  function success(data) {
    return { type: workflowConstants.EDIT_WORKFLOW_BY_ID_SUCCESS, data };
  }
  function failure(error) {
    return { type: workflowConstants.EDIT_WORKFLOW_BY_ID_FAILURE, error };
  }
}

function addConfiguredWorkflowById(workflowId, formData) {
  return (dispatch) => {
    dispatch(request());
    workflowServices.addConfiguredWorkflowById(workflowId, formData).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: workflowConstants.ADD_CONFIGURED_WORKFLOW_BY_ID_REQUEST };
  }
  function success(data) {
    return {
      type: workflowConstants.ADD_CONFIGURED_WORKFLOW_BY_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return {
      type: workflowConstants.ADD_CONFIGURED_WORKFLOW_BY_ID_FAILURE,
      error,
    };
  }
}

function runWorkflowByJobId(jobId) {
  return (dispatch) => {
    dispatch(request());
    workflowServices.runWorkflowByJobId(jobId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: workflowConstants.RUN_WORKFLOW_BY_JOB_ID_REQUEST };
  }
  function success(data) {
    return { type: workflowConstants.RUN_WORKFLOW_BY_JOB_ID_SUCCESS, data };
  }
  function failure(error) {
    return { type: workflowConstants.RUN_WORKFLOW_BY_JOB_ID_FAILURE, error };
  }
}
function getDatabricksJobStatus(runId) {
  return (dispatch) => {
    dispatch(request());
    workflowServices.getDatabricksJobStatus(runId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: workflowConstants.GET_DATABRICKS_JOB_STATUS_REQUEST };
  }
  function success(data) {
    return { type: workflowConstants.GET_DATABRICKS_JOB_STATUS_SUCCESS, data };
  }
  function failure(error) {
    return {
      type: workflowConstants.GET_DATABRICKS_JOB_STATUS_FAILURE,
      error,
    };
  }
}

function searchWorkflow(searchText, offset, limit) {
  return (dispatch) => {
    dispatch(request());
    workflowServices.searchWorkflow(searchText, offset, limit).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: workflowConstants.GET_ALL_WORKFLOW_REQUEST };
  }
  function success(data) {
    return { type: workflowConstants.GET_ALL_WORKFLOW_SUCCESS, data };
  }
  function failure(error) {
    return { type: workflowConstants.GET_ALL_WORKFLOW_FAILURE, error };
  }
}

function getWorkflowFilters() {
  return (dispatch) => {
    dispatch(request());
    workflowServices.getWorkflowFilters().then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: workflowConstants.GET_WORKFLOW_FILTERS_REQUEST };
  }
  function success(data) {
    return { type: workflowConstants.GET_WORKFLOW_FILTERS_SUCCESS, data };
  }
  function failure(error) {
    return { type: workflowConstants.GET_WORKFLOW_FILTERS_FAILURE, error };
  }
}

function applyWorkflowFilters(
  connection,
  user,
  workspace,
  startDate,
  endDate,
  search,
  offset,
  limit
) {
  return (dispatch) => {
    dispatch(request());
    workflowServices
      .applyWorkflowFilters(
        connection,
        user,
        workspace,
        startDate,
        endDate,
        search,
        offset,
        limit
      )
      .then(
        (data) => {
          dispatch(success(data));
          dispatch(alertActions.success(data.message));
        },
        (error) => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()));
        }
      );
  };

  function request() {
    return { type: workflowConstants.GET_ALL_WORKFLOW_REQUEST };
  }
  function success(data) {
    return { type: workflowConstants.GET_ALL_WORKFLOW_SUCCESS, data };
  }
  function failure(error) {
    return { type: workflowConstants.GET_ALL_WORKFLOW_FAILURE, error };
  }
}

function getGitRepoByConnectionId(connectionId) {
  return (dispatch) => {
    dispatch(request());
    workflowServices.getGitRepoByConnectionId(connectionId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: workflowConstants.GET_GIT_REPO_BY_CONNECTION_ID_REQUEST };
  }
  function success(data) {
    return { type: workflowConstants.GET_GIT_REPO_BY_CONNECTION_ID_SUCCESS, data };
  }
  function failure(error) {
    return { type: workflowConstants.GET_GIT_REPO_BY_CONNECTION_ID_FAILURE, error };
  }
}

function activateWorkflow(isActive, workflowId, workflowName) {
  return (dispatch) => {
    dispatch(request());
    workflowServices.activateWorkflow(isActive, workflowId, workflowName).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: workflowConstants.ACTIVATE_WORKFLOW_REQUEST };
  }
  function success(data) {
    return { type: workflowConstants.ACTIVATE_WORKFLOW_SUCCESS, data };
  }
  function failure(error) {
    return { type: workflowConstants.ACTIVATE_WORKFLOW_FAILURE, error };
  }
}


function getActiveWorkflowByConnectionId(connectionId) {
  return (dispatch) => {
    dispatch(request());
    workflowServices.getActiveWorkflowByConnectionId(connectionId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: workflowConstants.GET_ACTIVE_WORKFLOW_BY_CONNECTION_ID_REQUEST };
  }
  function success(data) {
    return { type: workflowConstants.GET_ACTIVE_WORKFLOW_BY_CONNECTION_ID_SUCCESS, data };
  }
  function failure(error) {
    return { type: workflowConstants.GET_ACTIVE_WORKFLOW_BY_CONNECTION_ID_FAILURE, error };
  }
}


